// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a01e1512","239":"27f4e7cf","667":"504d3574"}[chunkId] + ".chunk.js";
};